import React from "react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription, CardFooter } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Check } from "lucide-react";

const tiers = [
	{
		title: "Clinical Psychologist",
		price: "$180",
		description: "Expert support for complex mental health needs.",
		features: [
			"60-minute session",
			"Online or in-person",
			"Evidence-based therapy",
		],
		cta: "Book with Psychologist",
	},
	{
		title: "Psychotherapist / Counsellor / Social Worker",
		price: "$155",
		description: "Professional guidance for personal growth and wellbeing.",
		features: [
			"60-minute session",
			"Online or in-person",
			"Confidential support",
		],
		cta: "Book with Therapist",
	},
	{
		title: "Coaching",
		price: "$55",
		description: "Goal-focused sessions for personal or professional development.",
		features: [
			"60-minute session",
			"Online or in-person",
			"Actionable strategies",
		],
		cta: "Book Coaching",
	},
];

const Pricing = () => {
	return (
		<section className="w-full max-w-5xl mx-auto py-16 px-4">
			<div className="text-center mb-10">
				<h2 className="text-3xl font-bold mb-2">Session Pricing</h2>
				<p className="text-muted-foreground text-lg">
					All sessions are{" "}
					<span className="font-semibold">60 minutes</span> and can be attended{" "}
					<span className="font-semibold">online or in person</span>.
				</p>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
				{tiers.map((tier) => (
					<Card key={tier.title} className="flex flex-col h-full shadow-lg">
						<CardHeader>
							<CardTitle className="text-xl">{tier.title}</CardTitle>
							<div className="mt-2 text-4xl font-bold text-primary">
								{tier.price}
								<span className="text-base font-normal text-muted-foreground">
									/session
								</span>
							</div>
							<CardDescription className="mt-2">
								{tier.description}
							</CardDescription>
						</CardHeader>
						<CardContent className="flex-1">
							<ul className="space-y-2 mt-4">
								{tier.features.map((feature) => (
									<li
										key={feature}
										className="flex items-center gap-2 text-sm"
									>
										<Check className="w-4 h-4 text-green-600" />
										{feature}
									</li>
								))}
							</ul>
						</CardContent>
						<CardFooter>
              <a href="/intake_request_without_quiz/new">
                <Button className="w-full">
                  {tier.cta}
                </Button>
              </a>
						</CardFooter>
					</Card>
				))}
			</div>
		</section>
	);
};

export default Pricing;